/**
 * Ключи групп уведомлений Grasias — общий словарь сервера и клиента.
 *
 * Сервер строит по ним `dedup_key` при создании уведомления
 * (`server/rules/notification_dedup_rules.ts`), клиент по тем же строкам узнаёт
 * свои уведомления в бейдже раздела и гасит их при открытии карточки.
 * Набранные порознь, эти строки однажды разъедутся, и счётчик молча обнулится —
 * поэтому они живут здесь, в общем коде.
 */

/** Виды событий Grasias, попадающие в `payload.event` уведомления */
export const GRASIAS_NOTIFICATION_EVENTS = {
  /** Документ подрядчика с непривязанными строками */
  CONTRACTOR_DOC_PENDING: 'grasias_contractor_doc_pending',
  /** Входящая заявка передана менеджеру */
  INCOMING_LEAD_ASSIGNED: 'grasias_incoming_lead_assigned',
  /** Счёт поставщика отправлен на оплату */
  INVOICE_SENT_FOR_PAYMENT: 'grasias_invoice_sent_for_payment',
  /** Счёт поставщика согласован */
  INVOICE_APPROVED: 'grasias_invoice_approved',
  /** Счёт поставщика оплачен частично */
  INVOICE_PAID_PARTIAL: 'grasias_invoice_paid_partial',
  /** Счёт поставщика оплачен полностью */
  INVOICE_PAID: 'grasias_invoice_paid',
  /** Заявка переведена в статус «Отложен» */
  LEAD_POSTPONED: 'grasias_lead_postponed',
  /** Переданная заявка не взята в работу */
  LEAD_AWAITING_WORK: 'grasias_lead_awaiting_work',
  /** У менеджера есть заявки в работе без потенциальной суммы */
  LEAD_AMOUNT_MISSING: 'grasias_lead_amount_missing',
} as const;

export type GrasiasNotificationEvent =
  (typeof GRASIAS_NOTIFICATION_EVENTS)[keyof typeof GRASIAS_NOTIFICATION_EVENTS];

/** Префикс ключа группы уведомлений о документе подрядчика */
export const CONTRACTOR_DOC_KEY_PREFIX = 'grasias:contractor-doc:';

/** Ключ группы уведомлений одного документа подрядчика */
export function contractorDocNotificationKey(queryGuid: string): string {
  return `${CONTRACTOR_DOC_KEY_PREFIX}${queryGuid}`;
}

/** Код области уведомлений раздела «Таблицы Подрядчиков» */
export const CONTRACTOR_DOCS_SCOPE = 'grasias:contractor-docs';
